export default __webpack_public_path__ + "static/media/overAllTimeImg.d05c31e7.png";